<!-- 登入頁面 -->
<template>
  <el-container>
    <el-aside class="login_panel">
      <!-- 登入 -->
      <el-form
        v-if="userFormType === FORM_TYPE.LOGIN"
        :rules="loginRules"
        :model="loginForm"
        ref="loginForm"
        class="form forget"
        @submit.prevent.native="submitForm('loginForm')">
        <div class="website-logo"></div>
        <div class="form-title">登入</div>
        <div class="form-body">
          <el-form-item label="帳號" prop="email">
            <el-input v-model.trim="loginForm.email"></el-input>
          </el-form-item>
          <el-form-item label="密碼" prop="password">
            <el-input v-model.trim="loginForm.password" id="forget_pw_btn" type="password"></el-input>
            <div class="forget-btn" @click="changeUserFormType(FORM_TYPE.FORGET_PASSWORD)"> 忘記密碼 </div>
          </el-form-item>
          <el-form-item>
            <el-button
              v-loading="dataLoading"
              :disabled="dataLoading"
              native-type="submit"
              type="primary">
              登入
            </el-button>
            <el-button class='el-button sign_up' @click="changeUserFormType(FORM_TYPE.REGISTER_CHECK)">立即註冊</el-button>
          </el-form-item>
        </div>
      </el-form>

      <!-- 忘記密碼 -->
      <el-form
        v-if="userFormType === FORM_TYPE.FORGET_PASSWORD"
        :rules="forgetPasswordRules"
        :model="forgetPasswordForm"
        ref="forgetPasswordForm"
        class="form">
        <div class="form-back" @click="changeUserFormType(FORM_TYPE.LOGIN)">〈 回登入畫面</div>
        <!-- 預設畫面 -->
        <div v-if="!forgetPasswordForm.status" class="form-body">
          <div class="form-title-left">忘記密碼</div>
          <el-form-item label="請輸入當初註冊的信箱" prop="email">
            <el-input v-model.trim="forgetPasswordForm.email"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              v-loading="dataLoading"
              @click="submitForm('forgetPasswordForm')"
              :disabled="dataLoading"
              type="primary">
              送出
            </el-button>
          </el-form-item>
        </div>
        <!-- 成功申請忘記密碼畫面 -->
        <div v-if="forgetPasswordForm.status" class="form-body">
          <div class="form-title-forget">密碼已寄送到</div>
          <div class="form-title-forget">{{ forgetPasswordForm.email }}</div>
          <div class="form-desc">已寄發重設密碼連結信件到信箱，請<br>盡快打開信件進行後續設定！</div>
        </div>
      </el-form>

      <!--reinstall password-->
      <el-form
          v-if="userFormType === FORM_TYPE.REINSTALL"
          class="form"
          @submit.prevent
      >
        <div class="form-back" @click="changeUserFormType(FORM_TYPE.LOGIN)">〈 回登入畫面</div>
        <!-- 預設畫面 -->
        <div v-if="!forgetPasswordForm.status" class="form-body">
          <div class="form-title-left">重新設定密碼</div>
          <el-form-item label="輸入新密碼" prop="password">
            <el-input v-model.trim="reinstallState.password" type="password" @keyup.enter="reinstallPasswordSubmit" @input="checkReinstallInput"></el-input>
          </el-form-item>
          <div v-if="reinstallState.error.lengthNotEnough" class="error_re_txt text_left">密碼最短8個字</div>
          <div v-if="reinstallState.error.noCap" class="error_re_txt text_left">密碼須包含至少一個大寫英文字母、小寫英文字母、數字</div>

          <el-form-item label="確認新密碼" prop="password">
            <el-input v-model.trim="reinstallState.confirmedPassword" type="password" @keyup.enter="reinstallPasswordSubmit" @input="checkReinstallInput"></el-input>
          </el-form-item>
          <div v-if="reinstallState.error.dataNotComplete" class="error_re_txt text_left">欄位輸入不完整</div>
          <div v-if="reinstallState.error.passwordNotTheSame" class="error_re_txt text_left">新密碼兩次輸入須一致</div>

          <el-form-item>
            <el-button
                v-loading="reinstallState.dataLoading"
                @click="reinstallPasswordSubmit"
                :disabled="reinstallFormDisabled"
                type="primary">
              送出
            </el-button>
          </el-form-item>
        </div>

        <div class="user_action">
          <div class="">{{reinstallState.serverResponse}}</div>
        </div>
      </el-form>

      <!-- 低活耀度帳號 -->
      <el-form
        v-if="userFormType === FORM_TYPE.LOW_ACTIVE"
        :rules="lowActiveRules"
        :model="lowActiveForm"
        ref="lowActiveForm"
        class="form">
        <div class="form-back" @click="changeUserFormType(FORM_TYPE.LOGIN)">〈 回登入畫面</div>
        <div class="form-body">
          <div class="form-title-left">確認使用者帳號狀態</div>
          <div class="form-desc">因為此帳號已長時間未進行登入行為，為了確認此帳號還在使用中，請將您的信箱收到的認證碼，輸入下方的欄位，確認此帳號還在使用中。</div>
          <el-form-item label="請輸入驗證碼" prop="verificationCode">
            <el-input v-model.trim="lowActiveForm.verificationCode"></el-input>
            <el-button
              v-loading="dataLoading"
              @click="submitForm('lowActiveForm')"
              :disabled="dataLoading"
              type="primary">
              送出
            </el-button>
          </el-form-item>
        </div>
      </el-form>

      <!-- 註冊流程 -->
      <el-form v-if="userFormType === FORM_TYPE.REGISTER_CHECK"
        :model="registerCheckForm"
        ref="registerCheckForm"
        :rules="registerCheckRules"
        class="form"
      >
        <div class="form-back" @click="changeUserFormType(FORM_TYPE.LOGIN)">〈 回登入畫面</div>
        <div class="form-body">
          <div class="register-title">註冊 QuickPlan 帳號</div>

          <div class="register-form-subtitle"><span style="color:#f27474">*</span>姓名</div>
          <el-form-item prop="name">
            <el-input v-model.trim="registerCheckForm.name"></el-input>
          </el-form-item>

          <div class="register-form-subtitle"><span style="color:#f27474">*</span>公司名稱</div>
          <el-form-item prop="company_name">
            <el-input v-model.trim="registerCheckForm.company_name"></el-input>
          </el-form-item>

          <div class="register-form-subtitle"><span style="color:#f27474">*</span>Email(請填公司信箱)</div>
          <el-form-item prop="email">
            <el-input v-model.trim="registerCheckForm.email"></el-input>
          </el-form-item>

        <el-form-item>
        <el-button
          v-loading="dataLoading"
          @click="submitForm('registerCheckForm')"
          :disabled="!registerCheckEnabled"
          :style="registerCheckFormNextButtonStyle"
          type="primary">下一步
        </el-button>
        </el-form-item>
        <div v-if="registerCheckWarningAlreadyRegistered">
          <span :style="{color:'#ff7e86'}">此Email已經註冊過，請換一個或回登入畫面並使用”忘記密碼”以取回密碼</span>
        </div>
    </div>
</el-form>

<el-form v-if="userFormType === FORM_TYPE.REGISTER_MORE"
        :model="registerFillMoreInfoForm"
ref="registerFillMoreInfoForm"
class="form"
        >
        <div class="form-back" @click="changeUserFormType(FORM_TYPE.LOGIN)">〈 回登入畫面</div>
<div class="form-body register">
        <div class="more-title">讓我們更了解您 ？</div>

<div class="register-form-subtitle">職稱</div>
        <el-input v-model.trim="registerFillMoreInfoForm.job_title"></el-input>

        <div class="register-form-subtitle">聯絡電話</div>
        <el-input v-model.trim="registerFillMoreInfoForm.telephone"></el-input>

        <div class="register-form-subtitle">是否與 OneAD 合作過?</div>
<el-radio v-model="registerFillMoreInfoForm.collaboration" :label="false">否</el-radio>
        <el-radio v-model="registerFillMoreInfoForm.collaboration" :label="true">是</el-radio>

        <div class="register-form-subtitle">其他補充的訊息</div>
        <el-input type="textarea" :rows="5" v-model="registerFillMoreInfoForm.note"></el-input>

        <el-button
          @click="submitForm('registerFillMoreInfoForm')"
          :disabled="registerFillMoreDisabled"
          :loading="registerFillMoreLoading"
          type="primary">完成註冊
        </el-button>
        </div>

        </el-form>
      <!--   thanks message   -->
      <div v-if="userFormType === FORM_TYPE.REGISTER_THANKS_FORM" class="form">
        <div class="form-back" @click="changeUserFormType(FORM_TYPE.LOGIN)">〈 回登入畫面</div>
        <div class="form-content-area">
          <div class="thanks-title">您的註冊資料已送出！</div>
          <div class="thanks-content">本公司保留申請審核權，審核通過者將於1-3個工作天收到確認通知信。</div>
          <el-button
              @click="changeUserFormType(FORM_TYPE.LOGIN)"
              type="primary">返回登入畫面
          </el-button>
        </div>
      </div>

        <!-- 頁尾資訊 -->
        <div class="footer_copyright">OneAD ⓒ {{ dateFormat(new Date, 'YYYY') }}. All Rights Reserved</div>
</el-aside>
<!-- 背景圖 -->
<el-main id="user_bg"></el-main>
        </el-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import rootApi from '@/api/root'
import Cookies from 'js-cookie'
import dateFormat from 'date-fns/format'
import userApi from '@/api/user'

const FORM_TYPE = {
  REGISTER_CHECK: 'registerCheck',
  FORGET_PASSWORD: 'forgetPassword',
  LOGIN: 'login',
  REINSTALL: 'reinstall',
  REGISTER_THANKS_FORM: 'registerThanksForm',
  LOW_ACTIVE: 'lowActive',
  REGISTER_MORE: 'registerMore'
}

export default {
  name: 'Login',
  data () {
    return {
      FORM_TYPE: FORM_TYPE,
      dateFormat,
      userFormType: FORM_TYPE.LOGIN, // login ||forgetPassword || lowActive || registerCheck || registerMore
      // Login
      loginForm: {
        email: '',
        password: ''
      },
      loginRules: {
        email: [
          {
            type: 'email',
            required: true,
            message: '請輸入帳號',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '請輸入密碼',
            trigger: 'blur'
          }
        ]
      },
      // forgetPassword
      forgetPasswordForm: {
        email: '',
        status: false
      },
      forgetPasswordRules: {
        email: [
          {
            type: 'email',
            required: true,
            message: '請輸入帳號',
            trigger: 'change'
          }
        ]
      },
      // reinstall
      reinstallState: {
        token: '',
        error: {
          lengthNotEnough: false,
          noCap: false,
          dataNotComplete: false,
          passwordNotTheSame: false
        },
        password: '',
        confirmedPassword: '',
        dataLoading: false,
        inputDataIsValid: false,
        serverResponse: ''
      },
      // lowActive
      lowActiveForm: {
        verificationCode: ''
      },
      lowActiveRules: {
        verificationCode: [
          {
            required: true,
            message: '請輸入驗證碼',
            trigger: 'change'
          }
        ]
      },
      // register: fill basic and check email
      registerCheckForm: {
        name: null,
        company_name: null,
        email: null
      },
      registerCheckRules: {
        name: [{ required: true, message: '請輸入姓名', trigger: 'blur' }],
        company_name: [{ required: true, message: '請輸入公司名稱', trigger: 'change' }],
        email: [{ type: 'email', required: true, message: '請輸入 Email', trigger: 'change' }]
      },
      registerCheckEnabled: false,
      registerChecking: false,
      registerCheckWarningAlreadyRegistered: false,
      // register: fill more info and complete precess
      registerFillMoreInfoForm: {
        job_title: null,
        telephone: null,
        collaboration: false,
        note: null
      },
      registerFillMoreDisabled: false,
      registerFillMoreLoading: false
      // no check rules
    }
  },
  computed: {
    ...mapState('root', ['dataLoading']),
    reinstallFormDisabled () {
      return this.reinstallState.dataLoading || this.reinstallState.serverResponse !== ''
    },
    registerCheckFormNextButtonStyle () {
      return this.registerCheckEnabled ? {} : {
        'background-image': 'none',
        'background-color': '#c6c6c6',
        color: 'white'
      }
    }
  },
  watch: {
    userFormType () {
      this.forgetPasswordForm.email = ''
      this.forgetPasswordForm.status = false
      this.registerFillMoreLoading = false
      this.registerFillMoreDisabled = false
    },
    registerCheckForm: {
      handler () {
        this.$refs['registerCheckForm'].validate(valid => {
          this.registerCheckEnabled = valid
        })
      },
      deep: true
    }
  },
  created () {
    // 進入登入頁時清除資訊
    Cookies.remove('qp_access_token')
    window.sessionStorage.removeItem('qpUserInfo')
  },
  methods: {
    ...mapActions('root', ['setUserInfo', 'setDataLoading']),
    changeUserFormType (type) {
      if (type === FORM_TYPE.LOGIN && this.userFormType === FORM_TYPE.REINSTALL) {
        this.$router.push({ name: 'Login' })
      }
      this.userFormType = type
    },
    // 送出登入表單
    submitForm (formName) {
      // 驗證器
      this.$refs[formName].validate(valid => {
        if (valid) {
          switch (formName) {
            case 'loginForm':
              this.doUserLogin() // 登入
              break
            case 'lowActiveForm':
              this.doReactivateAccount() // 重啟帳號
              break
            case 'forgetPasswordForm':
              this.doResetPassword()
              break
            case 'registerCheckForm':
              this.doRegisterCheck()
              break
            case 'registerFillMoreInfoForm':
              this.doRegisterComplete()
              break
          }
        } else {
          console.log('err')
        }
      })
    },
    checkReinstallInputError ({ password, confirmedPassword }) {
      const regexPassword = value => /(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])/.test(value)

      const lengthNotEnough = password.length < 8
      const noCap = !regexPassword(password)
      const dataNotComplete = !password && !confirmedPassword
      const passwordNotTheSame = password !== confirmedPassword

      return {
        lengthNotEnough,
        noCap,
        dataNotComplete,
        passwordNotTheSame
      }
    },
    checkIfReinstallInputDataValid ({ dataNotComplete, lengthNotEnough, noCap, passwordNotTheSame }) {
      return !(dataNotComplete || lengthNotEnough || noCap || passwordNotTheSame)
    },
    checkReinstallInput () {
      this.reinstallState.error = this.checkReinstallInputError(this.reinstallState)
      this.reinstallState.inputDataIsValid = this.checkIfReinstallInputDataValid(this.reinstallState.error)
    },
    reinstallPasswordSubmit () {
      const { token, password, confirmedPassword } = this.reinstallState

      if (this.reinstallState.inputDataIsValid) {
        this.reinstallState.dataLoading = true
        userApi.resetPasswordUser({
          password,
          confirmedPassword,
          token
        }).then(() => {
          this.reinstallState.dataLoading = false
          this.reinstallState.serverResponse = '密碼已重新設定成功'
        }).catch((e) => {
          this.reinstallState.dataLoading = false
          this.reinstallState.serverResponse = e.response.data.message[0]
        })
      }
    },
    // 使用者登入
    doUserLogin () {
      this.setDataLoading(true)
      rootApi.userLogin(this.loginForm).then(res => {
        const lowActivity = res.data.data.low_activity
        if (lowActivity) {
          // 若為低活耀度帳號，則切換到低活躍度表單要求驗證
          this.changeUserFormType(FORM_TYPE.LOW_ACTIVE)
        } else {
          // 登入後取得token資訊，並寫入cookie中
          const tokenInfo = res.data.data.token_info
          if (tokenInfo) {
            const expires = tokenInfo.expires_in
            if (window.location.hostname.indexOf('localhost') > -1) {
              Cookies.set('qp_access_token', tokenInfo.access_token, { expires })
            } else {
              Cookies.set('qp_access_token', tokenInfo.access_token, {
                expires,
                domain: window.location.hostname.match(/(\.\w+)+/g)[0]
              })
            }
          }
          rootApi.getUserInfo(tokenInfo.access_token).then(res => {
            window.sessionStorage.setItem('qpUserInfo', JSON.stringify(res.data))
            this.$router.push({ name: 'Index' })
          })
        }
      }).catch(() => {
        this.$message.error('登入失敗，請檢查帳號密碼是否輸入錯誤')
      })
    },
    // 重新啟用帳號
    doReactivateAccount () {
      rootApi.reactivateAccount(this.lowActiveForm.verificationCode).then(res => {
        this.changeUserFormType(FORM_TYPE.LOGIN)
        this.$message.success('帳號已重新啟用，請重新登入')
      }).catch(() => {
        this.$message.error('錯誤的驗證碼，請重新輸入')
      })
    },
    // 重設密碼申請
    doResetPassword () {
      const showServerErrorMsg = () => {
        this.$message.error('發生錯誤，請稍後再試')
      }

      userApi.checkUserEmail(this.forgetPasswordForm.email).then(res => {
        if (res.data.data.is_exist) {
          rootApi.resetPassword(this.forgetPasswordForm.email).then(res => {
            this.forgetPasswordForm.status = true
          }).catch(showServerErrorMsg)
        } else {
          this.$message.error('此 Email 尚未註冊')
        }
      }).catch(showServerErrorMsg)
    },
    doRegisterCheck () {
      this.registerChecking = true
      userApi.checkUserEmail(this.registerCheckForm.email).then(res => {
        this.registerChecking = false
        this.registerCheckWarningAlreadyRegistered = res.data.data.is_exist

        if (!this.registerCheckWarningAlreadyRegistered) {
          this.changeUserFormType(FORM_TYPE.REGISTER_MORE)
        }
      }).catch(reason => {})
    },
    doRegisterComplete () {
      this.registerFillMoreDisabled = true
      this.registerFillMoreLoading = true
      userApi.applyQpAccount({ ...this.registerCheckForm, ...this.registerFillMoreInfoForm })
        .then(res => {
          this.registerFillMoreDisabled = false
          this.registerFillMoreLoading = false
          this.changeUserFormType(FORM_TYPE.REGISTER_THANKS_FORM)
        })
    }
  },
  mounted () {
    const checkIsReinstallProcess = ({ query }) => {
      return query && query.view === 'reinstall' && query.token
    }

    if (checkIsReinstallProcess(this.$route)) {
      this.reinstallState.token = this.$route.query.token
      this.changeUserFormType(FORM_TYPE.REINSTALL)
      document.title = 'OneAD QuickPlan 重新設定密碼'
    } else {
      document.title = 'OneAD QuickPlan 登入'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/z-index.scss';
.login_panel {
  position: relative;
  width: 380px !important;
  .form {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    background-color: #fff;
    .website-logo {
      margin-top: 50px;
      width: 300px;
      height: 100px;
      background-image: url('/ONEAD_202107.svg');
      background-size: cover;
    }
    &-back {
      margin-top: 20px;
      margin-left: 15px;
      margin-right: auto;
      font-size: 18px;
      color: #F5A623;
      cursor: pointer;
    }
    &-title {
      margin-top: 15px;
      color: #4a4a4a;
      font-size: 36px;
      &-left {
        margin-left: 3px;
        color: #4A4A4A;
        font-size: 24px;
      }
      &-forget {
        font-size: 24px;
      }
    }
    &-desc {
      margin-top: 20px;
      font-size: 18px;
      color: #4A4A4A;
      margin-left: 3px;
      letter-spacing: 0.5px;
      margin-bottom: 30px;
    }
    &-body {
      z-index: map-get($z-index, LoginBody);
      margin-top: 60px;
      width: 80%;
      background-color: #fff;
      .el-form-item {
        margin-bottom: 20px;
        &.is-success .el-input__inner {
          border-color: #dcdfe6 !important;
        }
        &__label {
          font-size: 18px;
          &::before {
            content: '' !important;
          }
        }
      }
      .el-button {
        margin-top: 50px;
        width: 100%;
        height: 50px;
        outline: none;
        border: none;
        background-image: linear-gradient(273deg, #4da1ff, #4da1ff);
        box-shadow: 0 4px 10px 0 rgba(216, 216, 216, 0.5), 0 4px 10px 0 rgba(166, 166, 166, 0.5);
        font-weight: unset;
        font-size: 18px;
      }
    }
  }

  .forget {
    &-btn {
      position: absolute;
      right: 0;
      z-index: map-get($z-index, LoginForget);
      color: #4da1ff;
      text-align: right;
      text-decoration: underline;
      // font-size: 18px;
      cursor: pointer;
      /*background: #fff;*/
      line-height: 16px;
      padding-left: 8px;
      font-size:16px;
      margin-top:-28px;
      margin-right:8px;
    }
  }
  .form-body .el-button.sign_up{
    background:#fff;
    margin-left:0;
    color:#4da1ff;
    margin-top:20px;
  }

  .footer_copyright {
    position: absolute;
    bottom: 0;
    padding-bottom: 15px;
    width: 100%;
    background-color: #fff;
    color: #9b9b9b;
    text-align: center;
    letter-spacing: 0;
    font-size: 12px;
  }
}

#user_bg {
  margin-top:0px;
  width: 100%;
  height: 100vh;
  background-image: url('../../assets/images/login_bg.jpg');
  background-position: center;
  background-size: cover;
}
/deep/ #forget_pw_btn{
  padding-right:80px;
}

@media only screen and (max-width: 991px){
  .login_panel{
    width:auto!important;
    min-width:320px;
    margin:0 auto;

  }
  #user_bg{
    display:none;
  }

  .login_panel .forget-btn{
  }
  .login_panel .form-body .el-button{
    margin-top:20px;
  }
  .form-title:before{
    content:'QuickPlan';
    display:inline;
  }

}

.login_panel .form-body{
  margin-top:40px
}
.login_panel .form-body .el-button{
  Margin-top:24px;
}
.login_panel .form .website-logo{
  Min-height:36px
}

.register{
  color: #4a4a4a;
}

.register-title{
  margin-top: 137px;
  font-size: 24px;
}
.more-title{
  margin-top: 77px;
  margin-bottom: 2px;
  font-size: 24px;
}

.form-content-area{
  margin: 0 40px;
}
.form-content-area>.el-button{
  width:100%;
}

.thanks-title{
  margin-top: 199px;
  font-size: 24px;
}
.thanks-content{
  margin: 25px 0;
  font-size: 18px;
}

.register-form-subtitle{
  font-size: 18px;
  margin-top: 15px;
  margin-bottom: 10px;
}
</style>
